import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Resource,
  TimeSheetFilter,
  Project,
  OptimizedTimeSheet,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  timeSheet: OptimizedTimeSheet;
  currentPage: number;
  canLoadMore: boolean;
  isDirty: boolean;
  retrieveTimeSheet(request: Boundaries["retrieveTimeSheet"]["request"]): void;
}

function useRetrieveTimeSheet(
  resource: Identifiable<Resource>,
  project: Identifiable<Project>,
  filter: TimeSheetFilter,
  size: number,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveTimeSheetRequestPending(
        project,
        resource,
        filter,
        size,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveTimeSheetRequestSuccess(
        project,
        resource,
        filter,
        size,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveTimeSheetRequestFailure(
        project,
        resource,
        filter,
        size,
      ),
    ),
    timeSheet: useSelector(() =>
      selector.getTimeSheet(project, resource, filter, size),
    ),
    currentPage: useSelector(() =>
      selector.getTimeSheetCurrentPage(project, resource, filter, size),
    ),
    canLoadMore: useSelector(() =>
      selector.canLoadMoreTimeSheet(project, resource, filter, size),
    ),
    isDirty: useSelector(() =>
      selector.isTimeSheetDirty(project, resource, filter, size),
    ),
    retrieveTimeSheet: core.retrieveTimeSheet,
  };
}

export { useRetrieveTimeSheet };
